import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {TriStateCheckbox} from 'primereact/tristatecheckbox';
import axios from "axios";

const TechnologyListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/technology' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setTechnologies(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const booleanFilterTemplate = (field) => {
    return (
      <TriStateCheckbox
        value={lazyParams.filters?.[field]?.value ?? null}
        onChange={(e) => {
          setLazyParams(prev => {
            const filters = {
              ...(prev.filters || {})
            };
            if (e.value === null || e.value === undefined) {
              delete filters[field];
            } else {
              filters[field] = {
                value: e.value,
                matchMode: 'equals'
              };
            }
            return {
              ...prev,
              first: 0,
              page: 0,
              filters
            };
          });
        }}
      />
    );
  };

  const booleanBodyTemplate = (rowData, field) => {
    return rowData?.[field] ? props.t('yes') : props.t('no');
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  history.push('/project/technology/read/' + rowData.id);
                }}/>
        {localStorage.getItem('roles').toString().includes('role_') && (localStorage.getItem('roles') || '[]').includes('role_technology_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'technology') {
                      history.push('/project/technology/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') && (localStorage.getItem('roles') || '[]').includes('role_technology_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/technology/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderTechnologyList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderTechnologyList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={technologies} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="active" header={t('columnActive')} dataType="boolean" sortable filter filterMatchMode="equals" filterElement={() => booleanFilterTemplate('active')} body={(rowData) => booleanBodyTemplate(rowData, 'active')}></Column>
        {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_SUBCONTRACTOR_READ') && (
          <Column field="subcontractor" header={t('columnPerformedBySubcontractor')} sortable filter filterMatchMode="equals" filterElement={() => booleanFilterTemplate('subcontractor')} body={(rowData) => {
              return (<>{rowData.subcontractor ? props.t('yes') : props.t('no')}</>)
            }}></Column>
        )}
        {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_STANDARD_TIME_READ') && (
          <Column field="standard_time" header={t('columnStandardTime')} sortable filter filterMatchMode="equals" filterElement={() => booleanFilterTemplate('standard_time')} body={(rowData) => {
              return (<>{rowData.standard_time ? props.t('yes') : props.t('no')}</>)
            }}></Column>
        )}
        {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_SCHEDULE_READ') && (
          <Column field="schedule" header={t('columnShiftSchedule')} sortable filter filterMatchMode="equals" filterElement={() => booleanFilterTemplate('schedule')} body={(rowData) => {
              return (<>{rowData.schedule ? props.t('yes') : props.t('no')}</>)
            }}></Column>
        )}
        {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_ASSIGNABLE_READ') && (
          <Column field="employee_assignable" header={t('columnEmployeeAssignable')} sortable filter filterMatchMode="equals" filterElement={() => booleanFilterTemplate('employee_assignable')} body={(rowData) => {
              return (<>{rowData.employee_assignable ? props.t('yes') : props.t('no')}</>)
            }}></Column>
        )}




        {/* <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column> */}
        {/* <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column> */}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(TechnologyListComponent);
